import Form from '../src/components/Form';

export default function Home() {
    return <Form />;
}
